import { Component, OnInit, EventEmitter, Output, ViewContainerRef, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomerSelectItem } from '../setup-equipment/setup-equipment.model';
import { GETSetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { FavouriteDialogService } from './favourite-dialog.service';
import { FamilyList, ModelSelectionFilter, SaveFavouritesParams, JobsiteSelectionFilter, ImplementTypeSortOrder, FilterImplementParams, GETDashboardColumnsVM } from './favourite-dialog-modal';
import { AppService } from '../../../app.service';
import { EquipmentService } from '../services/equipment.service';
import { DashboardSearchFilter } from '../dashboard/dashboard.model';
import { GenericIdName } from '../setup-implement/setup-implement.model';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-favourite-dialog',
  templateUrl: './favourite-dialog.component.html',
  styleUrls: ['./favourite-dialog.component.scss']
})
export class FavouriteDialogComponent implements OnInit {

  favName: string
  customerIds: number[] = []
  
  jobsiteId: number[] = []
  familyId: number[] = []
  makesId: number[] = []
  modelId: number[] = []
  implementTypeIds: number[] = []
  TypeID: number

  //load Lists
  customerList: CustomerSelectItem[] = [];
  slectedCutomerList: CustomerSelectItem[] = []
  makeList: CustomerSelectItem[] = []
  familyList: FamilyList[] = [];
  //jobsiteList: JobsiteSelectItem[] = []
  jobsiteList: GenericIdName[] = [];
  modelList: GenericIdName[] = [];
  implementTypeList: GenericIdName[] = []
  //implementTypeList: FilterImplementParams;
  FilterImplementParams
  showFavWindow: boolean = true
  filterMakeModelFamilyForExistingOnly = true;
  favId: number = 0
  favouriteDetail: SaveFavouritesParams

  implementTypeSortOrder: GenericIdName[] = [];
  filteredImplementList: ImplementTypeSortOrder[] = [];

  selectedImplementList: GenericIdName[] = [];
  GETDashboardColumnsList:GETDashboardColumnsVM[]=[]


  displayedColumns = ['condition','customer', 'jobsite', 'make', 'type', 'serialNo', 'AdditionalSerial', 'ImpBudget', 'Life','Residual', 'RemovelDate', 'status','warrantyStatus','buildno' ];     
  ColumnIds:number[] = []

  @Output() closeFavouriteWindow: EventEmitter<boolean> = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<FavouriteDialogComponent>,
    private _setupEquipmentService: GETSetupEquipmentService,
    public _favouriteDialogService: FavouriteDialogService,
    private _appService: AppService,
    public _equipmentService: EquipmentService,
    public toastr: NotificationsService, vRef: ViewContainerRef,
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit() {
    this.TypeID = 2;
    this.loadcustomers();
    this.loadMakeList();
    this._favouriteDialogService.getFamilyList();
    this.loadModelList();
    this.loadJobsites();
    

    if (this.data != null) {
      this.favId = this.data.favouriteId;
      if (this.favId > 0) {
        this.LoadImplementTypesForSelectedFavID();
        this.LoadDashboartColumnsFavourite_()
      }
      else {
        this.LoadImplementTypeList(1);// filter according to slections
        this.LoadDashboardColumns()
      }

    }
  }

  toppings = new FormControl();


  loadFavouriteDetailsById() {
    this._favouriteDialogService.LoadFavouriteDetails(this.favId).subscribe(r => {
      this.favouriteDetail = r;
      this.customerIds = r.Customers;
      this.jobsiteId = r.Jobsites;
      this.TypeID = r.DefaultView;
      this.familyId = r.Families;
      this.favName = r.FavouriteName;
      this.implementTypeIds = r.ImplementTypes;
      this.makesId = r.Makes;
      this.modelId = r.Models;
      this.LoadImplementTypeList(3);
    })

  }
  filteredList: FilterImplementParams[] = [];

  LoadImplementTypeList(value) {
    var params: DashboardSearchFilter = {
      Customers: this.customerIds,
      Jobsites: this.jobsiteId,
      Equipment: [],
      Families: this.familyId,
      Makes: this.makesId,
      Models: this.modelId,
      Implements: [],
      ImplementTypes: [],
      ComponentTypes:[],

      NoImplemets: false
    }
      this._favouriteDialogService.GetImplementTypesAvailable(params, 0).subscribe(r => {
        if (r) {
          this.implementTypeList = r;
          this.filteredList = []
          this.implementTypeList.map(x => {
            let obj = {
              Id: 0,
              Name: "",
              Check: false
            };
            let isChecked = false;
            let val = this.implementTypeIds.find(e => e == x.Id)
            if (val) {
              isChecked = true;
            }
            obj.Id = x.Id;
            obj.Name = x.Name;
            obj.Check = isChecked

            if (value == 3) {
              let pos: number = -1;
              if (this.filteredImplementList) {
                this.filteredImplementList.map(y => {
                  if (y.Id == x.Id) {
                    pos = y.Position;
                    if (pos > this.implementTypeList.length) {
                      pos = -1;
                    }
                    return
                  }
                })
              }
              if (pos < this.implementTypeList.length) {
                if (pos > -1) {
                  this.filteredList[pos] = (obj)
                }
                else {
                  if (pos == -1) {
                    this.filteredList.push(obj)
                  } else {
                    this.filteredList.push(obj)
                  }
                }
              } else {
                if (pos > this.implementTypeList.length) {
  
                } else {
                  this.filteredList.push(obj)
                }
            }
           
            }
            if(value==1){
              this.filteredList.push(obj)
            }
          })
        }
      });
    
    // if (value == 1) {
    //   this._favouriteDialogService.GetImplementTypesAvailable(params, 0).subscribe(r => {
    //     if (r) {
    //       this.implementTypeList = r;
    //       this.filteredList = []
    //       console.log("implementTypeList", r, "filteredList", this.filteredList, "IdimplementTypeIdss", this.implementTypeIds, "filyeredimplementList", this.filteredImplementList)
    //       this.implementTypeList.map(x => {
    //         let obj = {
    //           Id: 0,
    //           Name: "",
    //           Check: false
    //         };
    //         let count = 0;
    //         console.log(x, count++)
    //         let isChecked = false;
    //         let val = this.implementTypeIds.find(e => e == x.Id)
    //         if (val) {
    //           isChecked = true;
    //         }
    //         obj.Id = x.Id;
    //         obj.Name = x.Name;
    //         obj.Check = isChecked

    //         let pos: number = -1;
    //         if (this.filteredImplementList) {
    //           this.filteredImplementList.map(y => {
    //             if (y.Id == x.Id) {
    //               pos = y.Position;
    //               return
    //             }
    //           })
    //         }
    //         this.filteredList.push(obj)

    //       })
    //       console.log("filteredList", this.filteredList)
    //     }
    //   });

    // }



    if (value == 2) {
      this.UpdateFavourite(this.implementTypeIds)
    }


  }


  //Load Implement Types from sorting table
  LoadImplementTypesForSelectedFavID() {
    this._favouriteDialogService.GetImplementTypeSortOrder(this.favId).subscribe(res => {
      this.filteredImplementList = res
      this.loadFavouriteDetailsById();
    })

  }

  //Get Selected Implement
  GetSelectedImplementTypes() {
    var result = this.differenceWith(this.implementTypeList, this.filteredImplementList, 'Id');
    if (result) {
    }
  }


  differenceWith(a1, a2, prop) {
    return a1.filter(o1 => a2.filter(o2 => o2[prop] === o1[prop]).length === 0);
  }

  onCloseClick(): void {
    this.dialogRef.close({});
  }

  loadcustomers() {
    this._setupEquipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
    })
  }
  loadJobsites() {
    this.jobsiteList = null
    var params: JobsiteSelectionFilter = {
      Customers: this.customerIds,
    }
    this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
      if (r) {
        this.jobsiteList = r;
        this.LoadImplementTypeList(1);
      }
    });

  }

  loadMakeList() {
    this._setupEquipmentService.getMakeList().subscribe(r => {
      this.makeList = r;
    });
  }

  loadModelList() {
    this.modelList = null
    var params: ModelSelectionFilter = {
      Families: this.familyId,
      Makes: this.makesId
    }
    this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
      if (r) {
        this.modelList = r;
      }
    });

  }

  SaveFavourite() {

    if (this.favName == "" || this.favName == null) {
      this.toastr.error("Please enter Favourite name.");
    }
    else {
      var params: SaveFavouritesParams = {
        FavouriteName: this.favName,
        DefaultView: this.TypeID,
        Customers: this.customerIds,
        Jobsites: this.jobsiteId,
        Families: this.familyId,
        Makes: this.makesId,
        Models: this.modelId,
        ImplementTypes: this.implementTypeIds,
        FavouriteId: 0,
       // ImplementTypeSortOrder: this.filteredList, // need to update this
       ImplementTypeSortOrder: [],
        GETDashboardColumnsDetails:this.GETDashboardColumnsList
       
      }
      this._favouriteDialogService.SaveFavouriteDetails(params).subscribe(r => {
        if (r == 0) {
          this.toastr.error("Favourite name already exsist");
        }
        else if (r == 1) {
          this.toastr.success("Saved successfully");
          this.dialogRef.close({});
        }
        else {
          this.toastr.error("There was an error saving these changes.");
        }
      })
    }

  }


  UpdateFavourite(value) {
    this.implementTypeIds = [];

    this.filteredList.map(i => {
      if (i.Check) {
        this.implementTypeIds.push(i.Id)
      }
    })
    if (this.favName == "" || this.favName == null) {
      this.toastr.error("Please enter Favourite name.");
    }
    else {
      var params: SaveFavouritesParams = {
        FavouriteName: this.favName,
        DefaultView: this.TypeID,
        Customers: this.customerIds,
        Jobsites: this.jobsiteId,
        Families: this.familyId,
        Makes: this.makesId,
        Models: this.modelId,
        ImplementTypes: value,//this.implementTypeIds,
        FavouriteId: this.favId,
        // ImplementTypeSortOrder: this.filteredList, // need to update this
        ImplementTypeSortOrder: [],
        GETDashboardColumnsDetails:this.GETDashboardColumnsList,
        
      }
      this._favouriteDialogService.UpdateFavouriteDetails(params).subscribe(r => {
        if (r == 0) {
          this.toastr.error("Failed to update the favourite details");
        }
        else if (r == 1) {
          this.toastr.success("Updated successfully");
          this.LoadDashboartColumnsFavourite_()
          this.dialogRef.close({});
        }
        else {
          this.toastr.error("There was an error saving these changes.");
        }
      })
    }

  }


  onImplementListControlChanged(Id, event) {
    if (event.checked == true) {
      var ct = this.implementTypeIds.find(ct => ct == Id);
      if (!ct) {
        this.implementTypeIds.push(Id);

      }
    }
    else {
      var ct = this.implementTypeIds.find(ct => ct == Id);

      if (ct) {
        let array = this.implementTypeIds.filter(f => f != Id)
        this.implementTypeIds = array
      }
    }

  }

  /////////////////////////////////
  ///SORT IMPLEMMT TYPES/////
  ///////////////////////////////
  public down(event, item) {
    let index = this.filteredList.indexOf(item);
    if (index != this.filteredList.length - 1) {

      this.array_move(this.filteredList, index, index + 1)
    }

  }

  public up(event, item) {
    let index = this.filteredList.indexOf(item);
    if (index != 0) {
      this.array_move(this.filteredList, index, index - 1)
    }


  }

  public array_move(arr, old_index, new_index) {
    while (old_index < 0) {
      old_index += arr.length;
    }
    while (new_index < 0) {
      new_index += arr.length;
    }
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };



  onColumnControlChanged( value:any,Id, index){
    console.log(this.GETDashboardColumnsList)
    console.log(value.checked)
  }

  moveUp(item) { 
    if (item > 0) {
      let el = this.GETDashboardColumnsList[item];
      this.GETDashboardColumnsList[item] = this.GETDashboardColumnsList[item - 1];
      this.GETDashboardColumnsList[item - 1] = el;
    }
    console.log(this.GETDashboardColumnsList)


  }

  // move dwon by 1 postion in Array
 
  moveDown(item) {
    if (item !== -1 && item < this.GETDashboardColumnsList.length - 1) {
      let el = this.GETDashboardColumnsList[item];
      this.GETDashboardColumnsList[item] = this.GETDashboardColumnsList[item + 1];
      this.GETDashboardColumnsList[item + 1] = el;      
    console.log(item);
    console.log(this.GETDashboardColumnsList)


  }
}
LoadDashboardColumns(){
  this._favouriteDialogService.LoadDashboardColumns().subscribe(res=>{   
    this.GETDashboardColumnsList=res
   
  })
}

LoadDashboartColumnsFavourite_(){
  this._favouriteDialogService.LoadDashboartColumnsFavourite(this.favId).subscribe(res=>{
    console.log(res)
    this.GETDashboardColumnsList=res
  })
}

isFirstComponentInList(item, index) {
  if (this.GETDashboardColumnsList.indexOf(item) == 0) {
      return true;
  }
  return false;
}

isLastComponentInList(item, index) {
  if (this.GETDashboardColumnsList.indexOf(item) == this.GETDashboardColumnsList.length - 1) {
      return true;
  }
  return false;
}

}
